<template>
  <div class="transfer-container">
    <div class="title">Transfer between your trading accounts</div>
    <div class="body">In order to transfer funds from one Tradeview account to another, fill out the following form.
    </div>

    <div class="options">
      <CustomSelector v-model="source" placeholder="Source account" :options="sources"></CustomSelector>
      <CustomSelector v-model="target" placeholder="Target account" :options="targets"></CustomSelector>

      <input class="cabinet-input" type="text" placeholder="Sending amount" v-model="amount">

      <label class="input-checkbox">By checking the checkbox I understand that I have requested funds be transferred
        from by Tradeview LTD account to another of my own Tradeview LTD accounts.
        <input type="checkbox" checked="checked">
        <span class="checkmark"></span>
      </label>
    </div>

    <button class="red-button" @click="transfer">Transfer</button>
  </div>
</template>

<script>
import CustomSelector from "@/components/CustomSelector";

export default {
  name: "Transfer",
  components: {CustomSelector},
  data() {
    return {
      source: null,
      sources: [],
      target: null,
      targets: [],
      amount: null
    };
  },
  created() {
    window.addEventListener('keydown', this.reset);

    let userInfo = this.$store.state.user;
    if (userInfo != null) {
      if (userInfo.accounts != null) {
        this.supportLanguage = userInfo.preference.emailsLanguage;

      } else {
        this.supportLanguage = "ENGLISH";
      }
    }

    this.addSourceAccount("1234", "1234");
    this.addSourceAccount("5678", "5678");
    this.addTargetAccount("1234", "1234");
    this.addTargetAccount("5678", "5678");
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.reset);
  },
  methods: {
    addSourceAccount(accountValue, accountLabel) {
      this.sources.push({
        value: accountValue,
        text: accountLabel
      });
    },
    addTargetAccount(accountValue, accountLabel) {
      this.targets.push({
        value: accountValue,
        text: accountLabel
      });
    },
    transfer() {
      console.log('transfer!');
    },
    reset(e) {
      if (e.key === 'Escape') {
        this.source = null;
        this.target = null;
        this.amount = null;
      }
    }
  }
}
</script>

<style scoped>

</style>
